export const getReportAggregation = productFilter => {
  return productFilter ? null : 'productGroupId';
};

export const getReportMetricValue = (
  chartData,
  productGroups,
  metric,
  format,
  key
) => {
  const dataset = chartData?.dataset;

  if (!dataset) {
    return 0;
  }

  if (dataset.aggBy !== 'productGroupId') {
    return Number(dataset?.[metric]?.[format]?.[key] || 0);
  }

  return productGroups.reduce((total, productGroup) => {
    return total + Number(
      dataset?.[metric]?.[productGroup.name]?.[format]?.[key] || 0
    );
  }, 0);
};

export const getReportMetricKeys = (
  chartData,
  productGroups,
  metric,
  format
) => {
  const dataset = chartData?.dataset;

  if (!dataset) {
    return [];
  }

  if (dataset.aggBy !== 'productGroupId') {
    return Object.keys(dataset?.[metric]?.[format] || {});
  }

  return [...new Set(productGroups.flatMap(productGroup => {
    return Object.keys(dataset?.[metric]?.[productGroup.name]?.[format] || {});
  }))].sort();
};
